import { store } from "Redux/Store";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
const utcFormat = "YYYY-MM-DDTHH:mm";
const utcDateFormat = "YYYY-MM-DD";
const utcFormat1 = "YYYY-MM-DDTHH:mm:ss";

const ValidDate: (date: any) => string = (date) => {
  if (date && dayjs(date).isValid() && typeof date == "string") {
    const dateArr = date?.split(".");
    if (dateArr.length > 0) return dateArr[0];
    else return date;
  } else return "";
};
const CurrentTime: () => string = () => dayjs().format("HH:mm");
const CurrentDate: () => string = () => {
  const { dateFormat } = store.getState().user.myInfo;
  return dayjs().format(dateFormat);
};
const CurrentDateTime: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().format(dateTimeFormat);
};
const CurrentDateTimeSec: () => string = () => {
  const { dateTimeSecFormat } = store.getState().user.myInfo;
  return dayjs().format(dateTimeSecFormat);
};
const CurrentMonth: () => string = () => dayjs().format("MM");
const CurrentMonthName: () => string = () => dayjs().format("MMMM");
const CurrentYear: () => string = () => dayjs().format("YYYY");
const CurrentMonthStartDate: () => string = () => {
  const { dateFormat } = store.getState().user.myInfo;
  return dayjs().startOf("month").format(dateFormat);
};
const CurrentUTCDateTime: () => string = () => {
  const { utcDiff } = store.getState().user.myInfo;
  if (utcDiff) {
    const newDate = dayjs(CurrentDateTime())
      .add(-utcDiff, "hour")
      .format(utcFormat);
    return newDate + ":00.000Z";
  } else return new Date().toISOString();
};
const CurrentUTCDateTimeSec: () => string = () => {
  const { utcDiff } = store.getState().user.myInfo;
  if (utcDiff) {
    const newDate = dayjs(CurrentDateTimeSec())
      .add(-utcDiff, "hour")
      .format(utcFormat1);
    return newDate + "Z";
  } else return new Date().toISOString();
};
const TomorrowDateTime: () => string = () => {
  return dayjs().add(+1, "day").format(utcFormat);
};
const PreviousMonthDateTime: () => string = () => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs().add(-31, "day").format(dateTimeFormat);
};
const ToLocalDate: (data: any) => string = (data) => {
  const { dateFormat } = store.getState().user.myInfo;
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format(dateFormat);
  else return "";
};
const ToLocalDateTime: (data: any) => string = (data) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format(dateTimeFormat);
  else return "";
};
const UTCToLocalDateTime: (data: any) => string = (data) => {
  const { utcDiff, dateTimeFormat } = store.getState().user.myInfo;
  const newDate = ValidDate(data);
  if (newDate && dayjs.utc(newDate).isUTC()) {
    if (utcDiff) {
      return dayjs(newDate).add(utcDiff, "hour").format(dateTimeFormat);
    } else return dayjs.utc(newDate).local().format(dateTimeFormat);
  } else return "";
};
const UTCToLocalDateTimeGraph: (data: any) => string = (data) => {
  const { utcDiff } = store.getState().user.myInfo;
  const newDate = ValidDate(data);
  if (newDate && dayjs.utc(newDate).isUTC()) {
    if (utcDiff) {
      return dayjs(newDate).add(utcDiff, "hour").format("YYYY-MM-DDTHH:mm:ssZ");
    } else return dayjs.utc(newDate).local().format("YYYY-MM-DDTHH:mm:ss");
  } else return "";
};
const UTCToLocalDateTimeSec: (data: any) => string = (data) => {
  const { utcDiff, dateTimeSecFormat } = store.getState().user.myInfo;
  const newDate = ValidDate(data);
  if (newDate && dayjs.utc(newDate).isUTC()) {
    if (utcDiff) {
      return dayjs(newDate).add(utcDiff, "hour").format(dateTimeSecFormat);
    } else return dayjs.utc(newDate).local().format(dateTimeSecFormat);
  } else return "";
};
const MonthName: (month: number | null) => string = (month) => {
  if (month && month > 0)
    return dayjs()
      .month(month - 1)
      .format("MMMM");
  else return "";
};
const ToUTCDate: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format(utcDateFormat);
  else return "";
};
const ToUTCDateTime: (data: any) => string = (data) => {
  const { utcDiff } = store.getState().user.myInfo;
  const valid = ValidDate(data);
  if (valid) {
    const newDate = dayjs(valid).format(utcFormat);
    if (utcDiff) {
      const newDate2 = dayjs(newDate).add(-utcDiff, "hour").format(utcFormat);
      return newDate2 + ":00.000Z";
    } else return new Date(newDate).toISOString();
  } else return "";
};
const GetMonth: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("MM") || "";
  else return "";
};
const GetYear: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("YYYY") || "";
  else return "";
};

const GetTimeStamp: (date: any) => number = (date) => {
  return dayjs(date).valueOf();
};

const AddSubDay: (date: string, days: number) => string = (date, days) => {
  const valid = ValidDate(date);
  if (valid) return dayjs(date).add(days, "d").format(utcDateFormat);
  else return "";
};
const AddSubMin: (date: string, min: number) => string = (date, min) => {
  const valid = ValidDate(date);
  if (valid) return dayjs(valid).add(min, "m").format(utcFormat);
  else return "";
};
const CurrentDateSubtraction: (
  date: string,
  value: number,
  unit: dayjs.ManipulateType
) => string = (date, value, unit) => {
  const valid = ValidDate(date);
  const { dateFormat } = store.getState().user.myInfo;
  if (valid) return dayjs(valid).subtract(value, unit).format(dateFormat);
  else return "";
};
const ToDbUtcFormat: (date: string) => string = (date) => {
  const valid = ValidDate(date);
  if (valid) return valid + ":00.000Z";
  else return "";
};
const AddHoursToUTCDateTime: (number: number, date: any) => string = (
  number,
  date
) => {
  const valid = ValidDate(date);
  if (valid) {
    const newDate = dayjs(valid).add(-number, "hour").format(utcFormat);
    return newDate + ":00.000Z";
  } else return "";
};
const AddHoursUTCToLocalDateTime: (number: number, date: any) => string = (
  number,
  date
) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs(date).add(number, "hour").format(dateTimeFormat);
};

const AgeCalculator = (data: string): string => {
  const currentDate = CurrentDate();
  const currentYear = parseInt(dayjs(currentDate).format("YYYY"));
  const dobYear = parseInt(dayjs(data).format("YYYY"));
  return `${currentYear - dobYear}Y`;
};

const CalculateDuration: (start: string, end: string) => number = (
  start,
  end
) => {
  if (ValidDate(start) && ValidDate(end)) {
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const diff = endDate.diff(startDate, "minutes");
    return diff ? diff : 0;
  } else return 0;
};

const CalculateDurationInDays: (start: string, end: string) => number = (
  start,
  end
) => {
  if (ValidDate(start) && ValidDate(end)) {
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const diff = endDate.diff(startDate, "day");
    return diff ? diff : 0;
  } else return 0;
};

const HoursTimeZoneSwitch: (timezone: string) => number = (timezone) => {
  switch (timezone) {
    case "EST":
      return -5;
    case "CST":
      return -6;
    case "MST":
      return -7;
    case "PST":
      return -8;
    default:
      return 0;
  }
};

const TimeZoneRegionSwitch: (timezone: string) => {
  date: string;
  datetime: string;
  datetimesec: string;
  chartDateTimeSec: string;
} = (timezone) => {
  switch (timezone) {
    case "EST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    case "CST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    case "MST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    case "PST":
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
    default:
      return {
        date: "MM/DD/YYYY",
        datetime: "MM/DD/YYYY hh:mm A",
        datetimesec: "MM/DD/YYYY hh:mm:ss A",
        chartDateTimeSec: "MM/dd/yyyy hh:mm:ss a",
      };
  }
};

const SelectTimeZone: (tz: string) => string = (tz) => {
  switch (tz) {
    case "EST":
      return "America/New_York"
    case "CST":
      return "America/Chicago"
    case "MST":
      return "America/Denver"
    case "PST":
      return "America/Los_Angeles"
    default:
      return "Asia/Kolkata"
  }
};

const CurrentDateTimeInPatOrgLocTZ: (
  orgTZ: string
) => dayjs.Dayjs = (orgTZ) => {
  const newTZ = SelectTimeZone(orgTZ);
  return dayjs().tz(newTZ);
};

const ConvertDateTimeInPatOrgLocTZ: (
  orgTZ: string, dateTime: string
) => dayjs.Dayjs = (orgTZ, dateTime) => {
  const newTZ = SelectTimeZone(orgTZ);
  return dayjs(dateTime).tz(newTZ);
};

const CalculateTimeDiff: (diffMs: number) => string = (diffMs) => {
  // convert diff to a duration (hours/minutes/seconds)
  const diff = dayjs.duration(diffMs);

  // format hours part (if any)
  const h = diff.hours() > 0 ? `${diff.hours()}h ` : "";

  // format minutes part (if any)
  const m = diff.minutes() > 0 ? `${diff.minutes()}m ` : "";

  // always show seconds
  const s = `${diff.seconds()}s`;
  return `${h}${m}${s}`
};

const OrgMonthStartDateTime: (
  orgTZ: string, userTZ: string
) => string = (orgTZ, userTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const fullOrgTZ = SelectTimeZone(orgTZ)
  const fullUserTZ = SelectTimeZone(userTZ)

  // 1. Get month start in FROM timezone
  const monthStartInFromTZ = dayjs().tz(fullOrgTZ).startOf("month");

  // 2. Convert TO another timezone
  const converted = monthStartInFromTZ.tz(fullUserTZ);

  return converted.format(dateTimeFormat);
};

const OrgMonthEndDateTime: (
  fromTZ: string, toTZ: string
) => string = (fromTZ, toTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const fullFromTZ = SelectTimeZone(fromTZ)
  const fullToTZ = SelectTimeZone(toTZ)

  // 1. Get month start in FROM timezone
  const monthStartInFromTZ = dayjs().tz(fullFromTZ).endOf("month");

  // 2. Convert TO another timezone
  const converted = monthStartInFromTZ.tz(fullToTZ);

  return converted.format(dateTimeFormat);
};

const CheckTodayIsLastDayOfMonth: () => boolean = () => {
  return dayjs().isSame(dayjs().endOf("month"), "day");
};

const LocalTZToUTCDateTime: (
  datetime: string, localTZ: string
) => string = (datetime, localTZ) => {
  const fullLocalTZ = SelectTimeZone(localTZ);

  // Step 1: Attach timezone WITHOUT shifting (keepLocalTime = true)
  const zoned = dayjs(datetime).tz(fullLocalTZ, true);

  // Step 2: Convert to UTC
  const utcTime = zoned.utc();

  // Step 3: Format in required UTC shape
  const finalUtc = utcTime.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

  return finalUtc;
};

const UTCToLocalTZDateTime: (
  datetime: string, localTZ: string
) => string = (utcDateTime, localTZ) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  const fullLocalTZ = SelectTimeZone(localTZ);

  // Step 1 — Attach UTC WITHOUT parsing/shifting
  const asUTC = dayjs(utcDateTime).tz("UTC", true);

  // Step 2: Convert to target timezone
  const converted = asUTC.tz(fullLocalTZ);

  const finalLocal = converted.format(dateTimeFormat);

  return finalLocal;
};

const FormatToDayJS: (
  datetime: any, localTZ: string
) => Dayjs = (datetime, localTZ) => {
  const validDateTime = ValidDate(datetime);
  const fullLocalTZ = SelectTimeZone(localTZ);
  return dayjs(validDateTime).tz(fullLocalTZ, true);
};

const FormatIntoDateTime: (datetime: any) => string = (datetime) => {
  const { dateTimeFormat } = store.getState().user.myInfo;
  return dayjs(datetime).format(dateTimeFormat);
};

export default {
  CurrentDate,
  CurrentDateTime,
  CurrentMonth,
  CurrentMonthStartDate,
  CurrentMonthName,
  CurrentYear,
  CurrentUTCDateTime,
  CurrentUTCDateTimeSec,
  TomorrowDateTime,
  PreviousMonthDateTime,
  CurrentTime,
  ValidDate,
  ToUTCDate,
  ToUTCDateTime,
  UTCToLocalDateTime,
  UTCToLocalDateTimeGraph,
  UTCToLocalDateTimeSec,
  GetMonth,
  GetYear,
  GetTimeStamp,
  AgeCalculator,
  CurrentDateSubtraction,

  ToDbUtcFormat,

  HoursTimeZoneSwitch,
  ToLocalDate,
  ToLocalDateTime,
  CalculateDuration,
  CalculateDurationInDays,
  AddHoursToUTCDateTime,
  AddHoursUTCToLocalDateTime,
  TimeZoneRegionSwitch,
  MonthName,

  AddSubDay,
  AddSubMin,

  CurrentDateTimeInPatOrgLocTZ,
  ConvertDateTimeInPatOrgLocTZ,
  CalculateTimeDiff,
  OrgMonthStartDateTime,
  CheckTodayIsLastDayOfMonth,
  OrgMonthEndDateTime,
  LocalTZToUTCDateTime,
  UTCToLocalTZDateTime,
  FormatIntoDateTime,
  FormatToDayJS
};
